// src/api.js

export const API_ENDPOINTS = {
  ENCRYPT: '/encrypt',
  HASH: '/hash', // Make sure to add this endpoint as needed
};

/**
 * Function to send form data with file and JSON.
 * @param {Object} data - The data to be sent, can include files.
 * @returns {Promise<Object>} - The response from the server.
 */
export const postDataWithFiles = async (data) => {
  const formData = new FormData();
  
  // Append all data fields to the FormData object
  for (const key in data) {
    if (data[key] instanceof File) {
      formData.append(key, data[key]);
    } else {
      formData.append(key, data[key]); // Directly append values
    }
  }

  const response = await fetch(API_ENDPOINTS.ENCRYPT, {
    method: 'POST',
    body: formData,
  }); 

  return await response.json();
};

export const get_hashValue = async (algorithm, text, salt, useSalt, format, type) => {
  const response = await fetch(API_ENDPOINTS.HASH, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      algorithm,
      text,
      salt,
      useSalt,
      format,
      type,
    }),
  });  
  const data = await response.json();
  return data;
};